import { useGeocodeLookupApiV1GeocodeGet } from '#/shared/api/generated/shipment/theCargoShipment'
import type { GeoCodeResponse } from '#/shared/api/generated/shipment/models'
import { useDebouncedValue } from '#/shared/lib/hooks'

export const CITY_MIN_QUERY_LENGTH = 2
const DEBOUNCE_MS = 250

export function useCitySearch(query: string, options?: { enabled?: boolean }) {
  const normalized = query.trim()
  const debouncedQuery = useDebouncedValue(normalized, DEBOUNCE_MS)
  const hasQuery = debouncedQuery.length >= CITY_MIN_QUERY_LENGTH
  const enabled = (options?.enabled ?? true) && hasQuery
  const { data, isFetching } = useGeocodeLookupApiV1GeocodeGet(
    { q: debouncedQuery },
    { query: { enabled } },
  )
  const results: GeoCodeResponse[] = data?.data ?? []
  return {
    results,
    isLoading: isFetching && enabled,
    needsMoreInput: !hasQuery,
  }
}
